import { LoggerService } from '@nx-fe/services';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '@nx-fe/environment';
import { AlertInfo, AlertService, AlertTypeEnum } from '@nx-fe/alert';
import { XsI18nPipe } from '@nx-fe/pipes';

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  constructor(private injector: Injector, private xsI18n: XsI18nPipe) {
    super();
  }

  handleError(error: Error | HttpErrorResponse) {
    const logger = this.injector.get(LoggerService);
    logger.error(error);

    const production = environment.production;
    if (!production || error instanceof HttpErrorResponse) {
      const message = !production && error.message ? error.message : this.xsI18n.transform('global_error');
      const alertService = this.injector.get(AlertService);
      const alertInfo: AlertInfo = {
        type: AlertTypeEnum.Error,
        text: message,
        timeout: 10_000,
      };
      alertService.setInfo(alertInfo);
    }
  }
}
